import { render, staticRenderFns } from "./CreditEdit.vue?vue&type=template&id=65b643cf&scoped=true"
import script from "./CreditEdit.vue?vue&type=script&lang=js"
export * from "./CreditEdit.vue?vue&type=script&lang=js"
import style0 from "./CreditEdit.vue?vue&type=style&index=0&id=65b643cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b643cf",
  null
  
)

export default component.exports